



































import { Vue, Component, Prop } from 'vue-property-decorator';
import EmployeeSummary from '@/domain/schedule/employee/employee-summary.entity';
import EmployeeService from '@/domain/schedule/employee/employee.service';
import SelectionComponent from '@/shared/fields/selection.componet.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import debounce from '@/shared/utils/debounce';

@Component({
  components: {
    SelectionComponent,
    LabelSlot,
  },
})
export default class EmployeeFilter extends Vue {
  @Prop({
    type: String,
    default: 'Colaborador',
  }) label!: string;

  @Prop({
    type: String,
    default: 'Digite o nome...',
  }) placeholder!: string;

  @Prop({
    type: String,
    default: 'Nenhum colaborador encontrado...',
  }) noDataText!: string;

  employeeSelected: string[] = [];

  foundEmployees: EmployeeSummary[] = [];

  employeeName: string = '';

  loading: boolean = false;

  lastFilterEmployee: string = '';

  selected() {
    this.$emit('selected', this.employeeSelected);
  }

  findEmployeesDebounce(value: string) {
    debounce.debounce(() => this.findEmployees(value));
  }

  findEmployees(value: string) {
    if ((this.lastFilterEmployee !== value) && value) {
      this.lastFilterEmployee = value;
      if (value.length > 2) {
        const employeeExist = this.findEmployeesExistList(value);
        if (employeeExist.length > 0) return;
        this.loading = true;
        EmployeeService.findEmployeesByName(value)
          .then(data => this.foundEmployees.push(...data))
          .finally(() => this.loading = false);
      }
    }
  }


  findEmployeesExistList(value: string): EmployeeSummary[] {
    return this.foundEmployees
      .filter((employee: EmployeeSummary) => employee.name.toLowerCase()
        .includes(value.toLowerCase()));
  }
}
